const COLOR_ORDER = { red: 0, yellow: 1 };

export function expedienteImportantItems(expedientes = []) {
  return expedientes
    .filter(({ archivedAt }) => !archivedAt)
    .flatMap((expediente) =>
      (expediente.importantItems || []).map((item) => ({
        ...item,
        expediente: {
          cuij: expediente.cuij,
          numero: expediente.numero,
          caratula: expediente.caratula,
        },
      })),
    )
    .sort((left, right) => {
      const colorDifference =
        (COLOR_ORDER[left.trafficColor] ?? 9) -
        (COLOR_ORDER[right.trafficColor] ?? 9);
      if (colorDifference) return colorDifference;
      const inconsistencyDifference =
        Number(right.type === "inconsistency") -
        Number(left.type === "inconsistency");
      if (inconsistencyDifference) return inconsistencyDifference;
      const dateDifference = String(left.dueDate || "").localeCompare(
        String(right.dueDate || ""),
      );
      if (dateDifference) return dateDifference;
      return [left.expediente.cuij, left.id].join(":").localeCompare(
        [right.expediente.cuij, right.id].join(":"),
      );
    });
}

export function importantItemTone(item) {
  return item?.trafficColor === "red" ? "danger" : "warning";
}

export function importantItemStatusLabel(item) {
  if (item?.type === "inconsistency") return "Revisión procesal";
  if (item?.type === "manual") return "Recordatorio manual";
  if (item?.ruleId?.endsWith(".caducidad_instancia")) {
    return {
      upcoming: "En seguimiento",
      due_today: "Controlar hoy",
      overdue: "Control inmediato",
    }[item.status] || "Por revisar";
  }
  return {
    upcoming: "Próximo",
    due_today: "Vence hoy",
    overdue: "Vencido aparentemente",
  }[item?.status] || "Por revisar";
}

export function importantItemDateLabel(item) {
  if (item?.type === "inconsistency") return "Revisión necesaria";
  if (item?.type === "manual") return "Fecha de control";
  if (item?.actionNotice) return "Disponible desde";
  if (item?.unit === "calendar_months") return "Fecha de control";
  return "Vencimiento estimado";
}

export function importantItemReviewAction(item) {
  if (item?.type === "inconsistency") {
    return {
      label: "Marcar revisado",
      ariaLabel: "Marcar revisión procesal como revisada",
    };
  }
  if (item?.type === "deadline") {
    return {
      label: "Marcar cumplido",
      ariaLabel: "Marcar recordatorio automático como cumplido",
    };
  }
  return null;
}
